import { copyFormattedContent } from './copyFormattedContent';

/**
 * Gets clean inner text from an element, removing duplicate KaTeX content.
 * KaTeX renders formulas with both .katex-mathml (MathML for accessibility)
 * and .katex-html (visual rendering). innerText picks up text from both,
 * causing formula text to appear twice. This removes .katex-mathml before
 * extracting text.
 */
export const getCleanInnerText = (element: HTMLElement): string => {
  const clone = element.cloneNode(true) as HTMLElement;
  clone.querySelectorAll('.katex-mathml').forEach(el => el.remove());
  return clone.innerText;
};

export const copyElementContent = async (element: HTMLElement) => {
  const htmlContent = element.innerHTML;
  const plainText = getCleanInnerText(element);
  await copyFormattedContent(htmlContent, plainText);
};
